export default {
    name: "Busienss Name",
    logo: "/assets/images/pendo_logo.svg",
    landingImage:{
        imageOld: "/assets/images/mt-ranier.jpg", 
        image: "/assets/images/pendo_image_mobile.jpeg",
        imageSM: "/assets/images/pendo_image_mobile.jpeg",
        title: "Pendo Presbyterian Church",
        slogan: "Faith | Community | Service",
        text: "Join us every Sunday for service 12:00pm - 2:00pm."
    },
    mission: {
        title: "Our Mission",
        text: "Reach out to people of all nationalities, disciple them through teaching, serving and nurturing.\n\nBuild a community of faith, whose priest is Christ, whose presence is HIS Holy Spirit and whose passion is Great Comission."
    },
    aboutUs: {
        title: "ABOUT US",
        text: `
            Who are we?\n
            We are an active committed group of Christians who worship the Trinity - God the Father, the Son and the Holy Spirit.\n
            We are located in an inner Suburb of St. Louis, about two miles south of Lambert International Airport.
            \n\n
            Many of our members live within three miles of the church but others  others driveway 20 - 30 minutes to be part of this dynamic worshiping and serving community of believers.
            \n\n
            We are a mixed age congregation both men, women and children of all ages including teens and youth.  Our church is open to all.  We use English, Swahili, and Kikuyu as languages of communication so as to acommondate a wider society.
            \n\n
            What do Presbyterians believe?  The Presbyterian Church (USA) is part of the reformed family of Christians who place emphasis on the sovereignty of God, the authority of the scripture, justification by grace through faith and priesthood of all believers. 
            \n\n
            It is everyone’s job - ministers and lay people alike - to share this Good News with the whole world.  That is why the Presbyterian Church is governed at all levels by a combination of clergy and laity, men and women.
            \n\n
            For the spiritual growth of the congregation, meaningful worship services are key element. Jesus Christ has called His disciples to feed the hungry, clothe the naked and free the oppressed.
            \n\n
            We are committed to follow this calling in our congregation, our community, and the world at large.  Critical to the success of our vision is the active participation by each member.
            \n\n
            How can I join your Church?\n
            Become a part of our worshipping community, meet with our session (the ruling board) and attend catechism classes.  After this, you will be able to answer the following questions:\n
            Who is your Lord and Savior?  Will you be Christ’s faithful disciple, obeying His word and showing his love? Will you be a faithful member of this congregation, share in its worship and ministry through your prayers and gifts, your study and service, and so fulfill your calling to be a disciple of Jesus Christ?
            \n\n
            Come join us every Sunday Afternoon, Service starts at 12.00 noon.  Sunday school for ages three through teens begins at 1.00pm to 2.00pm.
            \n\n
            We have time for fellowship immediately after the worship.  Our building is fully accessible with an interior elevator and exterior entrance ramp.
            \n\n
            Pastor Samuel Kahuni - +1314-393-2081\n
            Worship Patron Elder Esther Kiarii - +1314-681-8709
        ` 
    },
    serviceTitle: "",
    imageSlideShow: [
        {
            original: "/assets/images/pendo_image.jpeg", 
            thumbnail: "/assets/images/pendo_image_sm.jpeg",
        },
        {
            original: "/assets/images/pendo_image2.jpeg",
            thumbnail: "/assets/images/pendo_image2_sm.jpeg",
        },
        {
            original: "/assets/images/pendo_image3.jpeg",
            thumbnail: "/assets/images/pendo_image3_sm.jpeg",
        },
        {
            original: "/assets/images/pendo_image4.jpeg",
            thumbnail: "/assets/images/pendo_image4_sm.jpeg",
        },
        {
            original: "/assets/images/pendo_ministers.jpeg",
            thumbnail: "/assets/images/pendo_ministers_sm.jpeg",
        },
        {
            original: "/assets/images/pendo_six_flags.jpeg",
            thumbnail: "/assets/images/pendo_six_flags_sm.jpeg",
        },
    ],
    serviceCards: [
        {
            title: "Ministries",
            text: "The Pendo Presbyterian Church is a mission-minded congregation, offering ministries to men, women and children.  We also extend our ministry to the Local Community and support regional, national and international mission through the Presbyterian Church (USA).\n\nPendo Church gives scholarship to vulnerable children, demonstrating Christ’s love through actions"
        },
        {
            title: "Worship",
             text: "Our Worship Service is on Sunday at 12.00pm CST and Sunday School is at 1:00 pm CST. \n\nWe are located at; \n9424 Everman Avenue, Overland, MO 63114. \n\nOur Worship Services are enhanced by the praise led by Praise team, (Choirs), men, Ladies and teens.  Our worship is facilitated by the use of overhead projections of images and hymns."
        },
        {
            title: "Upcoming Events",
             text: "\n- Trip for Children & parents (March) \n- Ladies Activities (June) \n- Retreat for Children & parents (Summer) \n- Vocational Bible School \n- Children & Teens (Summer) \n- Family Sunday (Summer) \n- Fall Camp for all (Fall) \n- Thanks giving (November)"
        },
        {
            title: "Service Live Stream",
            text: "Our Worship Service is live streamed every Sunday at 12:00 PM CST on Youtube: Pendo Presbyterian Church. YouTube link is located at the bottom of the page."
        }
    ],
    sideBySideContent: [
        {
            title: "Pastor Kungu",
            text: "\"And let us consider how to stir up one another to love and good works, not neglecting to meet together, as is the habit of some, but encouraging one another, and all the more as you see the Day drawing near.\" ~ Hebrews 10:24–25",
            image: "/assets/images/pastor_kungu.jpeg", //public/assets/images/pendo_preacher.jpg
            isImageOnTheLeft: true
        }
    ],
    contactDetails: {
        hideForm: true,
        showWithTwoColumns: true,
        title: "CONTACT DETAILS", 
        hideForm: true,
        phone: "+1 314-393-2081",
        additionalNumbers: [
            "+1 314-498-0138",
            "+1 314-397-5274"
        ],
        fax: "+1 555-555-5555",
        email: "business.name@gmail.com",
        address: "9424 Everman Ave. Overland MO 63114 USA",
        addressLink: "https://maps.app.goo.gl/2FjA5AYjPXbwZsUw8"
    },
    footer: {
        text: "Copyright 2025 | Designed by Kode Rush",
        socials: [
            {
                showIcon: false,
                icon: "facebook",
                link: "https://www.facebook.com/"
            },
            {
                showIcon: false,
                icon: "twitter",
                link: "https://www.twitter.com/"
            },
            {
                showIcon: false,
                icon: "instagram",
                link: "https://www.instagram.com/"
            },
            {
                showIcon: false,
                icon: "linkedin",
                link: "https://www.linkedin.com/"
            },
            {
                showIcon: true,
                icon: "youtube",
                link: "https://www.youtube.com/@pendochurch9116"
            }
        ]
    }
}